module.exports = __webpack_public_path__ + "static/media/Denver1.aa43f239.jpg";